import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=17949e76&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=ts&"
export * from "./navigation.vue?vue&type=script&lang=ts&"
import style0 from "./navigation.vue?vue&type=style&index=0&id=17949e76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17949e76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdminNavTabs: require('/home/vsts/work/1/s/frontend/components/nav/tabs/admin-nav-tabs.vue').default,NavigationPhone: require('/home/vsts/work/1/s/frontend/components/navigation-phone.vue').default,BuyCreditsCta: require('/home/vsts/work/1/s/frontend/components/cta/buy-credits-cta.vue').default,NavigationClientMenu: require('/home/vsts/work/1/s/frontend/components/navigation-client-menu.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VBadge,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer,VTab,VTabs})
